const Screens = {
    SignIn: {
        ForgotPassword: {
            Start: 'forgot-password/index',
            Finish: 'forgot-password/finish',
        },
    },
    Onboarding: {
        Biometrics: 'onboarding/biometrics',
        Notifications: 'onboarding/notifications',
    },
    Tabs: {
        Home: 'index',
        MyGuide: 'my-guide',
        Banking: 'banking',
        Roadmap: 'roadmap',
        Investment: 'investment',
    },
    Bills: {
        BillsHome: 'bills/bills-overview',
    },
    IncomeSplit: {
        Index: 'income-split/index',
    },
};

export const ModalScreens = {
    Bills_Details: 'bills/bill-details-new',
    Bills_ManualBill: 'bills/bill-add-new',
    Goals_Explanation: 'goals/goals-explanation',
    Guidance_BookSession: 'guidance-sessions/book-session',
    Guidance_CancelSession: 'guidance-sessions/cancel-session',
    Guidance_RescheduleSession: 'guidance-sessions/reschedule-session',
    Holistic_ConnectInstitution: 'holistic/connect-institution',
    Holistic_EditInstitutionAccount: 'holistic/edit-institution-account',
    Holistic_EditManualAccount: 'holistic/edit-manual-account',
    IncomeSplit_Edit: 'income-split/edit',
    MoneyMap_Results: 'money-map/results',
};

export default Screens;
